import maintenanceTypes from '@/store/dict/maintenance'
import { operateMaxShowLength } from '@/store/dict/config'
import { Button } from '@qs/ui'

export default function () {
  const searchBoxColumns = [
    {
      type: 'select',
      label: '项目名称(ID)',
      key: 'itemId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getProjectNames,
      },
    },
    {
      type: 'select',
      label: '项目类型',
      key: 'itemType',
      source: maintenanceTypes.projectTypesSource,
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '维保类型',
      key: 'maintenanceType',
      source: [{ label: '保养', value: 0 }, { label: '维修', value: 1 }],
      options: {
        clearable: true,
        filterable: true,
      },
    },
    // {
    //   type: 'select',
    //   label: '适用维修厂',
    //   key: 'storeId',
    //   source: [],
    //   sourceKey: { label: 'name', value: 'id' },
    //   options: {
    //     clearable: true,
    //     filterable: true,
    //     remote: true,
    //     remoteMthod: this.getMaintenanceStoreName,
    //   },
    // },
    {
      type: 'select',
      label: '状态',
      key: 'state',
      source: [{ label: '无效', value: 0 }, { label: '有效', value: 1 }],
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'input',
      label: '合作关系ID',
      key: 'collaborationId',
      options: {
        clearable: true,
        filterable: true,

      },
    },
    {
      type: 'select',
      label: '合作服务商名称(ID)',
      key: 'serviceId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getCompanyProviderName,
      },
    },
    {
      type: 'select',
      label: '租赁方案名称(ID)',
      key: 'rentPlanId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getRentPlanNames,
      },
    },
    {
      type: 'select',
      label: '租赁方案类型',
      key: 'rentPlanType',
      source: [{ label: '个人', value: 1 }, { label: '企业', value: 2 }],
      options: {
        clearable: true,
        filterable: true,

      },
    },
  ]

  const tableColumns = [
    {
      name: 'rentPlanNameWithId',
      align: 'center',
      columnProps: {
        label: '租赁方案名称(ID)',
        prop: 'rentPlanNameWithId',
        minWidth: 200,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 指定租赁方案详情页
                this.openRentPlanPage(row)
              },
            },
          }, row.rentPlanNameWithId),
        )
        return btns
      },
    },
    {
      name: 'rentPlanType',
      align: 'center',
      columnProps: {
        label: '租赁方案类型',
        prop: 'rentPlanType',
        minWidth: 120,
      },
      render: ({ row }) => {
        if (row.rentPlanType === 1) {
          return '个人'
        } else if (row.rentPlanType === 2) {
          return '企业'
        } else {
          return '--'
        }
      },
    },
    {
      name: 'collaborationId',
      align: 'center',
      columnProps: {
        label: '合作关系(ID)',
        prop: 'collaborationId',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 集团→采购→服务商管理→维保入驻审核，搜索指定ID
                this.openCollaborationPage(row)
              },
            },
          }, row.collaborationId),
        )
        return btns
      },
    },
    {
      name: 'serviceId',
      align: 'center',
      columnProps: {
        label: '合作服务商(ID)',
        prop: 'serviceId',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 集团→采购→服务商管理→服务商列表，搜索指定ID
                this.openservicePage(row)
              },
            },
          }, row.serviceId),
        )
        return btns
      },
    },
    {
      name: 'serviceName',
      align: 'center',
      columnProps: {
        label: '合作服务商名称',
        prop: 'serviceName',
        minWidth: 120,
      },
    },
    {
      name: 'itemId',
      align: 'center',
      columnProps: {
        label: '项目ID',
        prop: 'itemId',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 项目ID，车辆→维保管理→维保项目管理，搜索指定ID
                this.openProjectPage(row)
              },
            },
          }, row.itemId),
        )
        return btns
      },
    },
    {
      name: 'itemName',
      align: 'center',
      columnProps: {
        label: '项目名称',
        prop: 'itemName',
        minWidth: 120,
      },
    },
    {
      name: 'itemType',
      align: 'center',
      columnProps: {
        label: '项目类型',
        prop: 'itemType',
        minWidth: 120,
      },
      render: ({ row }) => {
        return maintenanceTypes.projectTypesDetails[row.itemType] || '--'
      },
    },
    {
      name: 'maintenanceType',
      align: 'center',
      columnProps: {
        label: '维保类型',
        prop: 'maintenanceType',
        minWidth: 120,
      },
      render: ({ row }) => {
        if (row.maintenanceType === 0) {
          return '保养'
        } else if (row.maintenanceType === 1) {
          return '维修'
        } else {
          return '--'
        }
      },
    },
    {
      name: 'itemPrice',
      align: 'center',
      columnProps: {
        label: '方案价格(元)',
        prop: 'itemPrice',
        minWidth: 120,
      },
    },
    {
      name: 'agreePrice',
      align: 'center',
      columnProps: {
        label: '协议价格(元)',
        prop: 'agreePrice',
        minWidth: 120,
      },
    },
    {
      name: 'usableStoreNameList',
      align: 'center',
      columnProps: {
        label: '适用维修厂',
        prop: 'usableStoreNameList',
        minWidth: 120,
      },
    },
    {
      name: 'usableCityList',
      align: 'center',
      columnProps: {
        label: '适用城市',
        prop: 'usableCityList',
        minWidth: 120,
      },
    },
    {
      name: 'stateName',
      align: 'center',
      columnProps: {
        label: '状态',
        prop: 'stateName',
        minWidth: 120,
      },
    },
  ]

  this.$nextTick(() => {
    tableColumns.push(
      {
        name: 'operate',
        align: 'center',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        render: ({ row }) => {
          return [
            <Button type="text" onClick={() => this.searchOrder(row)}>查看维保订单</Button>,
            <Button type="primary" onClick={() => this.changePayAccount(row)}>更换付款账户</Button>,
          ]
        },
      },
    )
  })
  return {
    searchBoxColumns,
    tableColumns,
  }
}
